import axios from 'axios'
import { csrfToken } from './csrf'

// Cookie-backed so a session change under the page cannot strand the token
function getCsrfToken(): string | null {
  return csrfToken()
}

// Configure axios defaults
axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken() || ''
axios.defaults.headers.common['Accept'] = 'application/json'

// Add request interceptor to ensure CSRF token is always fresh
axios.interceptors.request.use(
  (config) => {
    const token = getCsrfToken()
    if (token) {
      config.headers['X-CSRF-Token'] = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default axios
